import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/auth.jsx';
import { ADMIN_EMAIL } from '../lib/admin.js';
import { Logo } from './Logo.jsx';
import { PartagerApplication } from './PartagerApplication.jsx';

/**
 * Barre latérale des écrans connectés.
 *
 * Extraite du tableau de bord et des préférences, qui en portaient chacun une
 * copie : la même navigation à deux endroits finit toujours par diverger, et
 * c'est arrivé dès qu'il a fallu y ajouter une entrée.
 */
export function Laterale({ actif }) {
  const { user, deconnexion } = useAuth();
  const navigate = useNavigate();

  async function seDeconnecter() {
    // On quitte l'écran protégé *avant* de vider la session : dans l'autre
    // sens, le garde de route voit l'utilisateur disparaître et redirige vers
    // la page de connexion, alors qu'une déconnexion volontaire doit ramener
    // à l'accueil.
    navigate('/', { replace: true });
    await deconnexion();
  }

  const lien = (cle) => `laterale__lien${actif === cle ? ' laterale__lien--actif' : ''}`;

  return (
    <aside className="laterale">
      <Link className="marque" to="/">
        <Logo />
        HolidAI
      </Link>

      <Link className="bouton bouton--lien" to="/voyages/nouveau">
        + Nouveau voyage
      </Link>

      <nav aria-label="Navigation principale">
        <ul className="laterale__nav">
          <li>
            <Link className={lien('voyages')} to="/voyages">
              Mes voyages
            </Link>
          </li>
          <li>
            <Link className={lien('preferences')} to="/preferences">
              Préférences
            </Link>
          </li>
          <li>
            <PartagerApplication />
          </li>
          {user?.email === ADMIN_EMAIL && (
            <li>
              <Link className={lien('admin')} to="/admin">
                Administration
              </Link>
            </li>
          )}
          <li>
            <button className="laterale__lien" type="button" onClick={seDeconnecter}>
              Se déconnecter
            </button>
          </li>
        </ul>
      </nav>
    </aside>
  );
}
